export const calcCanGoNext = (
  currentKudoId: string,
  kudosArray: { tokenId: string }[],
) => {
  // find index of current kudos and move next
  const kudosData = kudosArray;
  const idx = kudosData.findIndex((item) => currentKudoId == item.tokenId);

  if (idx == kudosData.length - 1 || idx < 0) {
    // if last element cannot go next
    return { canGoNext: false, nextIdx: idx };
  } else {
    // if not last element cannot go next
    return { canGoNext: true, nextIdx: idx + 1 };
  }
};

export const calcCanGoBack = (
  currentKudoId: string,
  kudosArray: { tokenId: string }[],
) => {
  // find index of current kudos and move next
  const kudosData = kudosArray;
  const idx = kudosData.findIndex((item) => currentKudoId == item.tokenId);

  if (idx <= 0) {
    // if first element cannot go back
    return { canGoBack: false, prevIdx: 0 };
  } else {
    // if not last element cannot go next
    return { canGoBack: true, prevIdx: idx - 1 };
  }
};
